import { TaskInSearchModel } from "../../../models";

/**
 * * Модель ответа на получения задач
 */
export class TasksResponseModel {
  /**Элементы */
  Items!: Array<TaskInSearchModel>;
  /**Кол-во задач которые вернулись в ответе */
  Size!: number;
  /**Общее кол-во задач */
  Count!: number;
  /**Успешно ли */
  IsSuccess: boolean = true;

  constructor(obj?: Partial<TasksResponseModel>) {
    Object.assign(this, obj);
  }
}
